import React, { useState} from "react";
import { Analytics } from "@vercel/analytics/react";
import { NAV, TRANSLATIONS} from "./constants";
import { HomePage } from "./pages/HomePage";
import { SearchPage } from "./pages/SearchPage";
import { CheckPage } from "./pages/CheckPage";
import { UploadPage } from "./pages/UploadPage";
import { GuidesPage } from "./pages/GuidesPage";
import { AboutPage, ContactPage, PrivacyPage, TermsPage, DisclaimerPage } from "./pages/StaticPages";
import "./App.css"; 
export default function App() {
  const [page,  setPage]  = useState("home");
  const [menu,  setMenu]  = useState(false);
  const [theme, setTheme] = useState("dark");
  const [lang,  setLang]  = useState("en");

  const nav = (p) => { setPage(p); setMenu(false); };
  const toggleTheme = () => setTheme(t_theme => t_theme === "dark" ? "light" : "dark");
  const toggleLang  = () => setLang(l => l === "en" ? "ur" : "en");
  const t = (key) => TRANSLATIONS[lang][key] || key;

  return (
    <div className={`theme-root theme-${theme} lang-${lang}`} dir={lang === "ur" ? "rtl" : "ltr"}>
      <nav className="topnav">
        <div className="topnav-inner">
          <div className="logo" onClick={() => nav("home")}>
            <span className="logo-flag">🇵🇰</span>
            <span className="logo-text">Tax<em>Verify</em>pk.com</span>
          </div>
          <div className={`navlinks ${menu ? "open" : ""}`}>
            {NAV.map(l => (
              <button key={l.key} className={`navlink ${page === l.key ? "active" : ""}`} onClick={() => nav(l.key)}>{t(l.label)}</button>
            ))}
          </div>
          <div style={{ display:"flex", alignItems:"center", gap:8 }}>
            <button className="theme-toggle" onClick={toggleLang}>
              🌐
              <span className="theme-toggle-label">{t("lang_toggle")}</span>
            </button>
            <button className="theme-toggle" onClick={toggleTheme}>
              {theme === "dark" ? "☀️" : "🌙"}
              <span className="theme-toggle-label">{theme === "dark" ? t("theme_light") : t("theme_dark")}</span>
            </button>
            <button className="burger" onClick={() => setMenu(m => !m)}>{menu ? "✕" : "☰"}</button>
          </div>
        </div>
      </nav>

      <main>
        {page === "home"       && <HomePage nav={nav} t={t} />}
        {page === "search"     && <SearchPage t={t} />}
        {page === "check"      && <CheckPage t={t} />}
        {page === "upload"     && <UploadPage t={t} />}
        {page === "guides"     && <GuidesPage t={t} />}
        {page === "about"      && <AboutPage t={t} />}
        {page === "contact"    && <ContactPage t={t} />}
        {page === "privacy"    && <PrivacyPage t={t} />}
        {page === "terms"      && <TermsPage t={t} />}
        {page === "disclaimer" && <DisclaimerPage t={t} />}
      </main>

      <footer className="footer">
        <div className="footer-inner">
          <div className="footer-brand">🇵🇰 TaxVerifypk.com</div>
          <p className="footer-desc">{t("footer_desc")}</p>
          <div className="footer-links">
            {["about","contact","privacy","terms","disclaimer"].map(p => (
              <span key={p} className="footer-link" onClick={() => nav(p)}>{t("nav_" + p)}</span>
            ))}
          </div>
          <p className="footer-copy">© January 2026 TaxVerifypk.com · {t("footer_copy")}</p>
        </div>
      </footer>
      <Analytics />
    </div>
  );
}

